<template>
  <v-card v-if="prediction">
    <toolbar mode="prediction" :item="prediction"></toolbar>
    <prediction
      :applications="applications"
      :datasets="datasets"
      :prediction="prediction"
      @submitted="onSubmit"
    ></prediction>
  </v-card>
</template>

<script>
import toolbar from "@/components/toolbar"
import prediction from "@/components/Forms/Prediction"
import Applications from "@/api/applications"
import Predictions from "@/api/predictions"
import Datasets from "@/api/datasets"
export default {
  name: "EditPrediction",
  components: {
    toolbar,
    prediction
  },
  data() {
    return {
      prediction: null,
      applications: [],
      datasets: []
    }
  },
  created() {
    Predictions.retrieve(this.$route.params.uuid).then(response => this.prediction = response.data)
    Applications.list().then(response => this.applications = response.data)
    Datasets.list().then(response => this.datasets = response.data.filter(d => d.status == 'SUCCESS'))
  },
  methods: {
    onSubmit(prediction) {
      Predictions.update(
        this.$route.params.uuid, {
          name: prediction.name,
          application: prediction.application,
          methods: prediction.methods,
          dataset: prediction.dataset,
          config: prediction.config,
          user: this.user.id
        }
      ).then(_ => {
        this.notify("Updating prediction...")
        this.$store.commit("removeProgress", this.prediction.uuid)
        this.$router.push({ name: "predictionList" })
      })
    }
  }
}
</script>